import React, { useEffect } from "react";
import { Modal, Button, Space } from "antd";
import ReactDOM from "react-dom";
import liracrypt from "../Liracrypt/liracrypt";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

function ApiErrorComp(responseCode) {
  let modal ;
  function titleGen(text) {
    return (
      <h6
        style={{
          color: "#fff",
          margin: 0,
          fontWeight: 500,
          fontSize: "1rem",
        }}
      >
        {text}
      </h6>
    );
  }

  function okText(text) {
    return (
      <span
        style={{
          color: "#fff",
          margin: 0,
          fontWeight: 600,
        }}
      >
        {text}
      </span>
    );
  }

  setTimeout(() => {
    modal.destroy();
  }, 3000);

if (responseCode === 400) {
  modal = Modal.error({
    title: titleGen("Something Went Wrong !. Please Try Again."),
    okText: okText("OK"),
    centered: true,
  });
} else if (responseCode === 401) {
  modal = Modal.warning({
    title: titleGen("Session Ended !. Please Login."),
    okText: okText("Sign In"),
    centered: true,
    onOk: () => { },
  });
} else if (responseCode === 403) {
  modal = Modal.warning({
    title: titleGen("You are not authorized to access this function"),
    okText: okText("OK"),
    centered: true,
  });
} else if (responseCode === 407) {
  modal = Modal.warning({
    title: titleGen(
      "You are not authorized to access this function"
    ),
    okText: okText("OK"),
    centered: true,
  });
} else if (responseCode === 500) {
  modal = Modal.error({
    title: titleGen(
      "Internal Server Error (500) . Please Try Again After Sometime !"
    ),
    okText: okText("OK"),
    centered: true,
  });
} else {
  modal = Modal.error({
    title: titleGen("Oops Something Went Wrong !. Please Try Again"),
    okText: okText("OK"),
    centered: true,
  });
}
}

export default ApiErrorComp;
